import React, { useState } from 'react';

const Pagination = ({ totalItems, itemsPerPage, onPageChange }:any) => {
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(totalItems / 10);

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(prevPage => prevPage - 1);
      onPageChange(currentPage - 1 ,"prev");
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prevPage => prevPage + 1);
      onPageChange(currentPage + 1,"next");
    }
  };

  return (
    // <div>
    //   <button onClick={handlePrevious} disabled={currentPage === 1}>
    //     Previous
    //   <span>{`Page ${currentPage} of ${totalItems}`}</span>
    //   <button onClick={handleNext} disabled={(totalItems - currentPage) <= 10 }>
    //     Next
    //   </button>
    // </div>
     <div className='pagination'>
     <span>{`Page ${currentPage} of ${totalPages}`}</span>
     <button onClick={handlePrevious} disabled={currentPage === 1} className='data_privious cursor'></button>
     <button onClick={handleNext} disabled={totalPages <= currentPage} className='data_next cursor'></button>
   </div>
  );
};

export default Pagination;
